module.exports = {
  SelectReconciliationRules: 'Выбрать правила сверки',
  ReturnToReconciliationNewVersion: 'Вернуться к новой версии сверки',
  StartReconciliation: 'Начать сверку',
  Save: 'Сохранить',
  ManualReconciliation: 'Ручная сверка',
  CancelManualReconciliation: 'Отменить ручную сверку',
  ShowAllReconciliationCost: 'Показать все расходы по сверке',
  ShowConsistentReconciliationCost: 'Показать согласованные расходы',
  ShowPartiallyConsistentReconciliationFees: 'Показать частично согласованные расходы',
  ShowUnmatchedCosts: 'Показать несоответствующие расходы',
  Note: 'Пояснение:',
  Green: 'Зеленый',
  IndicatesConsistentReconciliationResults: 'означает совпадение результатов сверки;',
  Black: 'Черный',
  IndicatesNoCorrespondingChargeFound: 'означает, что соответствующие расходы не найдены;',
  Red: 'Красный',
  IndicatesInconsistentAmounts: 'означает несоответствие сумм;',
  Orange: 'Оранжевый',
  IndicatesManualReconciliationComplete: 'означает завершение ручной сверки;',
  IfEtcPleaseGoModule: 'Для обработки расхождений перейдите в модуль новой версии сверки.',
  ImportExternalCharges: 'Импорт внешних расходов',
  InternalSystemCharges: 'Внутренние расходы системы',
  IfMaintainReconciliationRulesClick: 'Для настройки правил сверки нажмите',
  ReconciliationRuleEngineConfiguration: 'настройку движка правил сверки.',
  ReconciliationConsistent: 'Совпадение сверки',
  Items: 'шт.',
  InconsistentAmounts: 'Несоответствие сумм',
  CorrespondingChargesNotFound: 'Расходы не найдены',
  ImportSucceeded: 'Импорт успешно завершен',
  CancelAllManualReconciliations: 'Отменить все ручные сверки',
  ExportAllComparisonResults: 'Экспорт всех результатов сравнения',
  ExportConsistentComparisonResults: 'Экспорт совпадающих результатов',
  ExportDiscrepancyComparisonResults: 'Экспорт различающихся результатов',
  BusinessNumber: 'Бизнес-номер',
  ShipName: 'Название судна',
  VoyageNumber: 'Рейс',
  ContainerNumber: 'Номер контейнера',
  ConfirmationStatus: 'Статус подтверждения',
  ChargeName: 'Наименование расхода',
  Currency: 'Валюта',
  PriceIncludingTax: 'Цена с налогом',
  PriceExcludingTax: 'Цена без налога',
  TaxRate: 'Налоговая ставка',
  TaxAmount: 'Сумма налога',
  Difference: 'Разница',
  ReconciliationAmount: 'Сумма сверки',
  UnitPrice: 'Цена за единицу',
  Quantity: 'Количество',
  InvoiceNumber: 'Номер счета-фактуры',
  ReconciliationResult: 'Результат сверки',
  ReconciliationRuleName: 'Название правила сверки',
  ComparisonOrder: 'Порядок сравнения',
  PleaseNeedToBeReconciliation: 'Пожалуйста, отметьте расходы, которые нужно сверять, и выполните ручную сверку.',
  ManualReconciliationSucceeded: 'Ручная сверка выполнена успешно',
  AreCancelAllManualTime: 'Вы уверены, что хотите отменить все данные ручной сверки?',
  Tips: 'Подсказка',
  Yes: 'Да',
  No: 'Нет',
  CancelAllManualReconciliationsSuccessful: 'Отмена всей ручной сверки выполнена успешно',
  RequestSucceededExporting: 'Запрос выполнен, идет экспорт!',
  SavedSuccessfully: 'Сохранено успешно',
  PleaseUseAndFillNumbers: 'Пожалуйста, выберите правила сверки и укажите порядок сравнения цифрами.',
  Unconfirmed: 'Не подтверждено',
  Confirmed: 'Подтверждено',
  ViewDetails: 'Просмотреть детали',
  Return: 'Назад',
  ShowAllReconciliationFees: 'Показать все расходы для сверки',
  ShowFullyReconciledFees: 'Показать совпадающие расходы',
  ShowPartiallyReconciledFees: 'Показать частично совпадающие расходы',
  ShowUnmatchedFees: 'Показать несоответствующие расходы',
  IndicatesReconciliationResultIsConsistent: 'Означает, что результаты сверки совпадают;',
  IndicatesCorrespondingFeeNotFound: 'Означает, что соответствующие расходы не найдены;',
  IndicatesAmountInconsistency: 'Означает, что суммы не совпадают;',
  IndicatesManualReconciliationCompleted: 'Означает, что ручная сверка завершена;',
  ImportExternalFees: 'Импорт внешних расходов',
  SystemInternalFees: 'Внутренние расходы системы',
  ViewFile: 'Просмотреть файл',
  System: 'Система',
  Voyage: 'Рейс',
  FeeName: 'Наименование расхода',
  TaxIncludedPrice: 'Цена с налогом',
  TaxExcludedPrice: 'Цена без налога',
  PleaseSelectOneRecord: 'Пожалуйста, выберите одну запись.',
  All: 'Все',
  BankName: 'Название банка',
  YouPermissionToViewData: 'У вас нет прав для просмотра этих данных',
  QuickRetrieval: 'Быстрый поиск:',
  Selected: 'Выбрано',
  QuickRetrievalBillNumber: 'Быстрый поиск: номер счета',
  BillClaims: 'Заявка на водный лист',
  FinancialReview: 'Финансовая проверка',
  QuickRetrievalBusinessNumber: 'Быстрый поиск: номер операции',
  QuickRetrievalWaterBillNumber: 'Быстрый поиск: номер водного листа',
  WaterBillClaims: 'Заявка на водный лист',
  Unused: 'Не использовано',
  PleaseAWaterBillRecord: 'Пожалуйста, выберите запись водного листа.',
  WaterReleasedAndCannotModified: 'Водный лист опубликован, изменения невозможны.',
  WaterClaimedAndCannotModified: 'Водный лист заявлен, изменения невозможны.',
  WaterReturnedAndCannotModified: 'Водный лист возвращен, изменения невозможны.',
  WaterRecordsAndCannotVoided: 'Водный лист имеет запись о списании, аннулирование невозможно.',
  WaterToFinancialVoucherVoided: 'Водяной знак уже экспортирован в финансовый документ, аннулирование невозможно.',
  Confirm: 'Подтвердить',
  Cancel: 'Отмена',
  NoBillRecordsToRelease: 'Нет записей водяных знаков для публикации.',
  NoRecordsToCancelRelease: 'Нет записей водяных знаков для отмены публикации.',
  OnlyCanRevokeTheBill: 'Только лицо, списавшее счет, может отменить водяной знак.',
  WaterCannotBeRevokedFirst: 'Проверенный водяной знак нельзя отменить, сначала отмените проверку.',
  ThisPleaseDeleteTheAgain: 'Этот водяной знак уже сгенерировал финансовый документ, удалите документ перед повторной отменой.',
  WaterBillRevocationSuccessful: 'Водяной знак успешно отменен.',
  WaterBillRegistration: 'Регистрация водяного знака',
  WaterBillNotSelected: 'Водяной знак не выбран.',
  AdvanceNoAdvancePaymentGenerated: 'Предоплата заявлена, но документ предоплаты не сгенерирован.',
  Claimed: 'Заявлено',
  ReceivableClaimCompleted: 'Дебиторская задолженность уже заявлена.',
  PrepaymentClaimCompleted: 'Предоплата уже заявлена.',
  NoInTheCurrentBill: 'Текущий водяной знак не имеет избыточной суммы для заявки.',
  PleaseDataToBeClaimed: 'Выберите данные для заявки.',
  DomesticBill: 'Внутренний счет',
  InvoicingMetForReconciliationStatus: 'Статус сверки не соответствует требованиям для выставления счета!',
  AddToBillQueryList: 'Добавить в список запросов счетов',
  ForeignBill: 'Международный счет',
  AgencyCommissionBill: 'Счет агентских комиссий',
  Bill: 'Счет:',
  CreatePaymentRequestSelectFee: 'Создание заявки на оплату - выбор расходов',
  SettlementTheBillCannotEmpty: 'Агент по расчету счета не может быть пустым!',
  CreatePaymentRequestDetailedInformation: 'Создание заявки на оплату - детали',
  ReconciliationBill: 'Сверка счетов',
  QuickRetrievalReconciliationBillNumber: 'Быстрый поиск: номер сверки',
  Payable: '(К оплате)',
  Receivable: '(К получению)',
  ReconciliationByFee: 'Сверка - по расходам',
  ReconciliationByBusiness: 'Сверка - по операциям',
  SelectImportTemplateSolution: 'Выбор схемы импорта шаблона',
  Prompt: 'Подсказка',
  TemplateSolutionName: 'Название схемы шаблона',
  ToMaintainImportTemplatesClick: 'Для обслуживания шаблона импорта нажмите',
  BasicDataImportTemplateSolutions: 'Базовые данные - схема импорта шаблона.',
  PleaseSelectASolution: 'Выберите схему',
  PleaseSettlementUnitBeforeImporting: 'Проверьте расчетную единицу перед импортом',
  NoFoundNoNeedReconcile: 'Связанные расходы не найдены, сверка не требуется',
  PleaseBasicDataImportSolution: 'Для обслуживания перейдите в схему импорта шаблона базовых данных',
  ImportErrorPleaseReImport: 'Ошибка формата импорта, повторите импорт',
  PleaseSelectATemplate: 'Выберите шаблон',
  YouHavePermissionToOpen: 'У вас нет прав для открытия',
  Module: 'модуля',
  ViewPaymentRequestForm: 'Просмотр заявки на оплату',
  CreatingFormFailedPleaseAgain: 'Не удалось создать заявку на оплату, сохраните снова!',
  ShanghaiAirFreightPayment: 'Оплата авиаперевозки Шанхай',
  PaymentRequestDirect: 'Прямая заявка на оплату',
  IncludesReSelectPaymentNumber: 'Включает уже выставленные счета, выберите снова! Номер заявки на оплату:',
  CantDirectlyChangeConfigurationAgain: 'Невозможно провести финансовую проверку напрямую, измените настройки и попробуйте снова!',
  Invoicing: 'Выставить счет',
  QueryMethod: 'Способ запроса',
  ByFee: 'По расходам',
  ByBusiness: 'По операциям',
  IncludeReceivables: 'Включая дебиторскую задолженность',
  NoteFilteredOutFullyBusiness: 'Примечание: В этом интерфейсе отфильтрованы полностью погашенные расходные операции',
  ConvertedToRMB: 'Эквивалент в RMB:',
  NextStep: 'Далее',
  NotFound: 'Не найдено',
  CorrespondingPrintTemplate: 'Соответствующий шаблон печати',
  WarehouseEntryNumber: 'Номер склада',
  BookingNumber: 'Номер бронирования',
  CutOffDate: 'Дата закрытия заявки',
  ProjectNumber: 'Номер проекта',
  OverseasCustomerService: 'Зарубежный клиентский сервис',
  PaymentApplicationNumber: 'Номер заявки на оплату',
  BillNumber: 'Номер счета',
  SettlementObject: 'Объект расчета',
  PickUpType: 'Тип грузоперевозки',
  MasterBillNumber: 'Основной номер',
  HouseBillNumber: 'Дополнительный номер',
  EntrustingUnit: 'Доверительная организация',
  BusinessType: 'Тип операции',
  BusinessDate: 'Дата операции',
  VesselVoyage: 'Название судна и рейс',
  DeparturePort: 'Порт отправления',
  DestinationPort: 'Порт назначения',
  StartingStation: 'Станция отправления',
  TerminusStation: 'Станция назначения',
  TransitStation: 'Транзитная станция',
  DestinationPortAgent: 'Агент порта назначения',
  Sales: 'Продажи',
  Operation: 'Операции',
  CustomerService: 'Клиентский сервис',
  Documentation: 'Документация',
  BusinessReferenceNumber: 'Референс операции',
  CustomBusinessType: 'Пользовательский тип операции',
  Accrued: 'Начислено',
  FinancialDate: 'Финансовая дата',
  DomesticForeign: 'Внутренний/Международный',
  IncomeAndExpensesType: 'Тип дохода/расхода',
  ExpenseStatus: 'Статус расхода',
  Auditor: 'Проверяющий',
  ExpenseName: 'Наименование расхода',
  Unit: 'Единица',
  WriteOffAmount: 'Сумма погашения',
  UnwrittenOffAmount: 'Непогашенная сумма',
  ContactPerson: 'Контактное лицо',
  Creator: 'Создатель',
  CreationDate: 'Дата создания',
  Remark: 'Примечание',
  CorrelationNumber: 'Связанный номер операции',
  DelegationCorrelationNumber: 'Связанный номер поручения',
  Carrier: 'Перевозчик',
  ConfirmationDate: 'Дата подтверждения',
  ExpenseConfirmer: 'Подтверждающий расходы',
  RouteResponsiblePerson: 'Ответственный за маршрут',
  BillingDate: 'Дата выставления счёта',
  BillingHeader: 'Реквизиты для счёта',
  NeedForInvoicing: 'Требуется ли счёт',
  ConfirmationRemark: 'Подтверждающее примечание',
  AccountingDate: 'Дата списания',
  BusinessStatus: 'Статус операции',
  CustomField1: 'Пользовательское поле 1',
  CustomField2: 'Пользовательское поле 2',
  CustomField3: 'Пользовательское поле 3',
  ReceiptAndPaymentDate: 'Дата оплаты/поступления',
  SalesDepartment: 'Отдел продаж',
  ChooseExpense: 'Выбор расходов',
  CreatePaymentApplicationChooseExpense: 'Создание заявки на оплату - выбор расходов',
  Other: 'Прочее',
  YouViewOrPrintOthers: 'У вас нет прав на просмотр файлов, загруженных или распечатанных другими пользователями.',
  BookingAgent: 'Агент по бронированию',
  PleaseSelect: 'Пожалуйста, выберите необходимое',
  ProvisionalBusinesses: 'Начисленные операции',
  ChangeOrderApprovalSuccess: 'Изменение заявки успешно проверено',
  ThisIsNotForProvision: 'Эта операция не ожидает начисления, начисление невозможно!',
  ForPleaseChooseProvisionedBusiness: 'Не начислено, выберите начисленные операции!',
  FrontendErrorCallbackFailed: 'Ошибка фронтенда: сбой обратного вызова',
  RouteManager: 'Ответственный за маршрут',
  ThisFieldCannotBeEmpty: 'Это поле не может быть пустым',
  OperationAllowedToBeEmpty: 'Действие не может быть пустым',
  OperatingAllowedToBeEmpty2: 'Операционный отдел не может быть пустым',
  OperatingAllowedToBeEmpty3: 'Операционный филиал не может быть пустым',
  DesignatedFreightForwarder: 'Указанный грузовой агент',
  OriginPortAgent: 'Агент порта отправления',
  TransportationCompany: 'Транспортная компания',
  Warehouse: 'Склад',
  CustomsBroker: 'Таможенный брокер',
  CustomsDeclaration: 'Требуется ли таможенное оформление',
  PickingStorage: 'Внутренняя упаковка/хранение',
  Storage: 'Требуется ли хранение',
  CargoType: 'Тип сбора груза',
  ActualBillingWeight: 'Фактический вес для расчёта',
  QuotationNature: 'Характер согласованной цены',
  BookingType: 'Характер бронирования',
  AllWriteOffs: 'Полное списание',
  BusinessCannotBeEmpty: 'Операция не может быть пустой!',
  ReviewSuccess: 'Проверка успешна',
  ReviewFailed: 'Проверка не пройдена',
  ColumnDataConversionRendering: 'Преобразование и отображение данных столбца:',
  SelectActualReceiptAndPayment: 'Выбрать фактический доход/расход',
  SingleWriteOffDetailXls: 'Детализация списания (одна запись).xls',
  SentOut: 'Уже отправлено!',
  FetchDate: 'Дата получения',
  ReturnDate: 'Дата возврата',
  DeclarationDate: 'Дата декларирования',
  SailingDate: 'Дата отплытия',
  OperationDate: 'Дата операции',
  Contracted: 'Контракт подписан',
  ContractExpired: 'Контракт аннулирован',
  Uncontracted: 'Контракт не подписан',
  ViewReturnOrderFiles: 'Просмотреть документы на возврат',
  OnlyWithTheSameStatus: 'Можно печатать только документы с одинаковым статусом.',
  HouseWaybillNumber: 'Номер частичной накладной',
  RevokeFetch: 'Отменить получение',
  SentOutDate: 'Дата отправки',
  ProvisionedBusiness: 'Резервируемые операции',
  ForPleaseChooseUnprovisionedBusiness: 'Уже зарезервировано, выберите незарезервированные операции!',
  ProvisionSuccess: 'Резервирование успешно',
  CancellationProvisionsSuccess: 'Отмена резервирования успешна',
  ProvisionReview: 'Проверка резервирования',
  ProvisionDate: 'Дата резервирования',
  Booking: 'Бронирование места',
  CustomsClearance: 'Таможенное оформление',
  FormalHouseWaybill: 'Проформа частичной накладной',
  CommodityInspection: 'Товарная экспертиза',
  Fumigation: 'Фумигация',
  ForeignTrade: 'Внешняя торговля',
  CustomerAttribute: 'Атрибуты клиента',
  Dropdown: 'Выпадающий список',
  OrderChannel: 'Канал заказа',
  ArrivalDate: 'Дата прибытия в порт',
  ShippingOfBillOfLading: 'Место отправки по коносаменту',
  OriginPortPOL: 'Порт отпр.(POL)',
  DeliveryPlace: 'Место доставки',
  Route: 'Маршрут',
  FinalDestination: 'Конечный пункт назначения',
  ShippingCompany: 'Судоходная компания',
  ShipAgent: 'Судовой агент',
  TradeMethod: 'Вид торговой операции',
  MasterWaybillTransportTerms: 'Условия перевозки по основной накладной',
  HouseWaybillTransportTerms: 'Условия перевозки по частичной накладной',
  MasterWaybillFreightTerms: 'Условия фрахта по основной накладной',
  MasterWaybillPaymentLocation: 'Место платежа по основной накладной',
  HouseWaybillFreightTerms: 'Условия фрахта по частичной накладной',
  HouseWaybillPaymentLocation: 'Место платежа по частичной накладной',
  TradeTerms: 'Торговые условия',
  CargoDimensions: 'Габариты груза',
  SpecialPriceExplanation: 'Описание специального предложения',
  GrossWeightEntrustedActual: 'Брутто-вес (заявленный/фактический)',
  VolumeEntrustedActual: 'Объем (заявленный/фактический)',
  Packing: 'Упаковка',
  NumberOfSmallPieces: 'Количество мест',
  SmallPiecePacking: 'Упаковка по количеству мест',
  ChargeableWeightRT: 'Расчетный вес RT',
  EnglishProductName: 'Наименование товара на английском',
  ShippingMarks: 'Маркировка',
  HSCode: 'Код HS',
  ChineseProductName: 'Наименование товара на китайском',
  CargoSales: 'Продажа грузоперевозок',
  OperatingCompany: 'Операционная компания',
  OperatingDepartment: 'Операционный отдел',
  OperationRequirements: 'Требования к операции',
  OperationTips: 'Подсказки по операции',
  AdditionalFeeTerms: 'Условия дополнительных сборов',
  WarehouseEntryInformation: 'Информация о приемке на склад',
  Remarks: 'Примечание',
  CustomField4: 'Пользовательское поле 4',
  Shipper: 'Грузоотправитель',
  SecondNotifyParty: 'Второе уведомляемое лицо',
  EntrustedInformation: 'Информация о поручении',
  VipCooperativeCustomer: 'VIP-клиент',
  DetailedInformation: 'Подробная информация',
  Transshipment: 'Транзит',
  AdditionalInformation: 'Дополнительная информация',
  DoorToDoorLoadingCollection: 'Погрузка/вывоз с адреса',
  SelfPickupSelfDelivery: 'Самовывоз и самодоставка',
  AutomaticAllocation: 'Автоматическое распределение груза',
  WarehousingInformation: 'Получение складского помещения',
  CargoBoxInformation: 'Информация о контейнерах',
  OperationInformation: 'Операционная информация',
  CustomInformation: 'Пользовательская информация',
  CustomerShippingInformation: 'Информация об отправке клиента',
  CodeRetrieval: 'Поиск по коду',
  OperationCannotBeEmpty: 'Операция не может быть пустой',
  OperationDepartmentCannotBeEmpty: 'Операционный отдел не может быть пустым',
  OperationBranchCannotBeEmpty: 'Операционный филиал не может быть пустым',
  DesignatedFreightAgent: 'Указанный агент по грузу',
  DeparturePortAgent: 'Агент порта отправления',
  Client: 'Организация-доверитель',
  DeclaringCustoms: 'Таможенное оформление',
  ContainerPackingWarehouse: 'Консолидация/хранение',
  WarehouseService: 'Хранение',
  PricingNature: 'Характер договорной цены',
  BookingNature: 'Характер бронирования',
  PleaseARecordToView: 'Выберите запись для просмотра',
  WriteOff: 'Полное списание',
  AgeOfAccount: 'Срок задолженности по текущей накладной',
  CommissionAmount: 'Сумма комиссионных',
  TradeType: 'Тип торговли',
  PayableWriteOffStatus: 'Статус погашения к оплате',
  ReceivableWriteOffStatus: 'Статус погашения к получению',
  Date: 'Дата',
  PleaseEnterTheReviewDate: 'Введите дату проверки',
  PleaseConfirmTheReviewDate: 'Подтвердите дату проверки',
  FailedToGetDetails: 'Не удалось получить детали',
  AfterForFinancialReviewContinue: 'После печати анализа прибыли данная операция будет отправлена на финансовую проверку, и изменения будут невозможны. Продолжить?',
  Warning: 'Предупреждение',
  PleaseNumberBeforePrintingTable: 'Введите номер контейнера и печатайте анализ прибыли.',
  PleaseSelectCost: 'Выберите расходы',
  ConfirmTheSingleCostDate: 'Вы уверены, что хотите изменить финансовую дату для отдельного расхода?',
  CostFinancialDateModificationSuccessful: 'Финансовая дата расхода успешно изменена',
  ConfirmModifyTheFinancialDate: 'Вы уверены, что хотите изменить финансовую дату?',
  FinancialDateModificationSuccessful: 'Финансовая дата успешно изменена',
  ReviewBusinessDateDoContinue: 'Дата проверки раньше даты операции. Продолжить?',
  ConfirmReviewOfTheseOrders: 'Подтверждаете проверку этих документов?',
  ThisIsNotIn: 'Данная операция не в статусе [',
  AllowedToReviewCheck: '], проверка запрещена. Проверьте!',
  ConfirmToAllowAmendments: 'Разрешить изменение документа?',
  AmendmentAllowedSuccessful: 'Изменение документа разрешено',
  NoOrNotInStatus: 'Расходы не выбраны или не в статусе проверки',
  ConfirmCancellationOfReview: 'Подтверждаете отмену проверки?',
  CostStatusUpdateSuccessful: 'Статус расходов успешно обновлен',
  NoOrNotInStatus2: 'Расходы не выбраны или не в статусе отправки',
  NoOrNotInStatus3: 'Расходы не выбраны или не в статусе проверки!',
  NoOrNotInStatus4: 'Расходы не выбраны или не в статусе отправки!',
  ConfirmToCancelReview: 'Подтверждаете отмену проверки?',
  CancelReviewSuccessful: 'Проверка успешно отменена',
  LCLIndividuallyPleaseReviewBill: 'Сборные накладные нельзя проверить отдельно, проверьте основную накладную.',
  FrontEndErrorCallbackFailed: 'Ошибка фронтенда: сбой обратного вызова',
  CostStatusUpdateSuccessful2: 'Статус расходов успешно обновлен.',
  PleaseStaffInformationBeforePrinting: 'Введите данные продавца перед печатью!',
  TheNotEnteredSales: '以下几单没有输入销售人员信息：\n',
  PleaseEnterBeforePrinting: '\n请输入后再打印！',
  PleaseWantToModifyDate: 'Выберите операцию для изменения даты',
  BusinessDateModificationSuccessful: 'Дата операции успешно изменена',
  PleaseSelectOnlyOneRecord: 'Выберите только одну запись',
  InvoicePool_OnlyWithAttachment: 'С вложениями',
  PleaseSelectBusiness: 'Выберите операцию.',
  SelectedDataIncludes: 'В выбранных данных есть операции в статусе',
  StatusAllowedToReviewCheck: ', проверка запрещена. Проверьте!',
  StatusToCancelReviewCheck: ', отмена проверки запрещена. Проверьте!',
  BatchReviewFailed: 'Ошибка массовой проверки',
  ReviewLessThanBusinessContinue: 'Дата проверки раньше даты операции. Продолжить?',
  ConfirmToReviewTheseOrders: 'Подтверждаете проверку этих документов?',
  FinancialReviewList: 'Список финансовых проверок',
  QueryFailed: 'Ошибка запроса',
  PleaseBusinessYouWantPrint: 'Выберите операции для печати',
  SendEmail: 'Отправить письмо',
  N1ContactAndEmailMaintained: '1. Контакты и электронные почты не настроены:',
  N1AMaintainedContactEmail: '1. Выберите настроенные контакты и электронные почты:',
  N2PleaseAddOtherEmails: '2. Укажите дополнительные электронные почты:',
  MultipleShouldBeSeparatedCommas: '(Разделяйте несколько адресов электронной почты запятыми)',
  Send: 'Отправить',
  InvoiceUuidCannotBeEmpty: 'UUID счета не может быть пустым!',
  SettlementIdCannotBeEmpty: 'ID расчетной единицы не может быть пустым!',
  PleaseEnterEmail: 'Введите электронную почту',
  SendLog: 'Журнал отправки',
  Sender: 'Отправитель',
  YouViewOtherPeoplesFiles: 'У вас нет прав на просмотр файлов, загруженных или распечатанных другими пользователями.',
  CostName: 'Наименование расхода',
  PaymentType: 'Тип оплаты/поступления',
  BillingExchangeRate: 'Курс для выставления счета',
  BillingAmount: 'Сумма счета',
  BillBusinessNumber: 'Номер счета/операции',
  BillBusinessDate: 'Дата счета/операции',
  PriceExclusiveOfTax: 'Цена без налога',
  ResetColumn: 'Сбросить столбцы',
  OnlyNumberCanBeSelected: 'Можно выбрать только 1 номер счета!',
  Used: 'Использовано',
  Example8180onlyUSDIsInvoice: 'Например: USD:355/курс:6.8180/этот счет только в долларах',
  PleaseNote: 'Примечания:',
  ChangesTheNextInvoiceConfiguration: 'Настройки вступят в силу со следующего счета после сохранения',
  EBeLessThanCharacters: 'Примечание к электронному счету должно быть менее 100 символов',
  PaperBeLessThanCharacters: 'Примечание к бумажному счету должно быть менее 200 символов',
  AutomaticTheTextDoesntLine: 'Автоматический перенос строки при переполнении',
  PDFDisplayUpToLines: 'В PDF-формате примечание к счету отображается максимум в три строки',
  InvoiceType: 'Тип счета',
  RMBExpenseItemName: 'Наименование статьи расходов в RMB',
  USDExpenseItem: 'Статья расходов в USD',
  DefaultItemName: 'Использовать название по умолчанию?',
  Billing: 'Выставить счет',
  Add: 'Добавить',
  InternationalFreightForwardingFee: 'Международный агентский фрахт',
  InternationalShippingFee: 'Международный агентский морской фрахт',
  InternationalFreightServiceFee: 'Услуги международного экспедитора',
  FreightForwardingFee: 'Экспедиторские услуги',
  MarkBill: 'Пометить счет',
  MarkCharge: 'Пометить расходы',
  MarkJob: 'Пометить операцию',
  PleaseSelectChargeToMark: 'Пожалуйста, выберите расходы для пометки.',
  MarkRecordExistsMarkedCharge: 'В записи есть помеченные расходы, пожалуйста, выберите непомеченные расходы.',
  PleaseSelectJobToMark: 'Пожалуйста, выберите операцию для пометки.',
  MarkRecordExistsMarkedJob: 'В записи есть помеченные операции, пожалуйста, выберите непомеченные операции.',
  MarkRecordExistsNoMarkedCharge: 'В записи есть непомеченные расходы, пожалуйста, выберите помеченные расходы.',
  MarkRecordExistsNoMarkedJob: 'В записи есть непомеченные операции, пожалуйста, выберите помеченные операции.',
  AnnotationDate: 'Дата пометки:',
  Annotator: 'Кто пометил:',
  InvoiceInquiry: 'Поиск счетов',
  QuickSearchInvoiceNumber: 'Быстрый поиск: номер счета',
  SecondaryDownload: 'Скачиваний',
  Sent: 'Отправлено',
  Unsent: 'Не отправлено',
  Total: 'Итого',
  VoidingBulkOperationsPleaseSelectClickVoid: 'Аннулирование счетов не поддерживает пакетную обработку\nВыберите один счет и нажмите [Аннулировать]',
  OriginalToReissueTheExpenses: 'Исходные расходы будут сторнированы. При повторном выставлении счета убедитесь в правильности указанных расходов!',
  OriginalTheSystemWillExpenses: 'Исходные расходы будут сторнированы, система автоматически создаст идентичные расходы!',
  CreditSuccess: 'Корректировка проведена успешно!',
  BankAccount: 'Банковский счет',
  OnlyElectronicInvoicesPleaseType: 'Поддерживается только массовая загрузка электронных счетов-фактур. Проверьте тип счета.',
  TotalSelection: 'Всего отмечено',
  StatusUnknown: 'Статус неизвестен',
  UnwrittenAmount: 'Несписанная сумма',
  WrittenOffAmount: 'Списанная сумма',
  SearchByExpense: 'Поиск по расходам',
  QuickSearchBusinessNumber: 'Быстрый поиск: номер операции',
  SearchByBusiness: 'Поиск по операциям',
  SearchByBill: 'Поиск по счетам',
  QuickSearchBillNumber: 'Быстрый поиск: номер счета',
  SearchByReconciliationBill: 'Поиск по выпискам',
  QuickSearchReconciliationBillNumber: 'Быстрый поиск: номер выписки',
  SearchByExpenseCredit: 'Поиск по расходам (корректировка)',
  SearchByBusinessCredit: 'Поиск по операциям (корректировка)',
  SearchByBillCredit: 'Поиск по счетам (корректировка)',
  SearchByReconciliationBillCredit: 'Поиск по выпискам (корректировка)',
  SearchingYouSureYouAgo: 'Если выбранный период превышает 2 года, это повлияет на скорость загрузки данных. Вы уверены, что хотите запросить данные старше двух лет?',
  SelectClosingDate: 'Выберите дату закрытия',
  ClosingDate: 'Дата закрытия:',
  FinancialClosing: 'Финансовое закрытие',
  BusinessClosing: 'Операционное закрытие',
  ClosingPerson: 'Ответственный за закрытие',
  ClosingMonth: 'Месяц закрытия',
  ClosingBranch: 'Филиал закрытия',
  ClosingType: 'Тип закрытия',
  TheHasAlreadyBeenClosed: 'Выбранный месяц уже закрыт.',
  ClosingSuccess: 'Закрытие успешно',
  PleaseSelectAClosingRecord: 'Выберите запись о закрытии.',
  TheBeenAuditedAndCancelled: 'Запись о закрытии проверена, отмена невозможна.',
  AreWantToCancelRecord: 'Вы уверены, что хотите отменить запись о закрытии?',
  ClosingRecordCancelled: 'Запись о закрытии отменена',
  Year: 'Год',
  Month: 'Месяц',
  PleaseSelectARecord: 'Выберите запись.',
  AreWantToAuditRecord: 'После проверки запись о закрытии нельзя отменить. Вы уверены?',
  OperationSuccessful: 'Операция успешно выполнена.',
  ToYouSureYouAudit: 'После отмены проверки можно отменить дату закрытия. Вы уверены?',
  NoMatchingPrintTemplatesFound: 'Соответствующий шаблон печати не найден',
  FinancialAudit: 'Финансовая проверка',
  HangingWaterBill: 'Водный счет',
  ReceivedPayment: 'Поступление средств',
  GotReceipt: 'Получение квитанции',
  InternationalBill: 'Международный счет',
  AgencySharingBill: 'Счет агентских отчислений',
  PaymentRequestQuery: 'Поиск заявок на оплату',
  QuickSearchPaymentRequestNumber: 'Быстрый поиск: номер заявки на оплату',
  ChangeExpenseApplicationQuery: 'Поиск заявок на изменение расходов',
  QuickSearchApplicationSerialNumber: 'Быстрый поиск: регистрационный номер заявки',
  SearchByInvoice: 'Поиск по счету',
  BankAccountNumber: 'Банковский счет',
  NoCorrespondingPrintTemplateFound: 'Соответствующий шаблон печати не найден',
  SearchByCost: 'Поиск по расходам',
  ReleasePleasePrepareForWithholding: 'Документы выпущены, подготовьтесь к удержанию груза.',
  StatusUpdatedSuccessfully: 'Статус успешно обновлен.',
  BillOfLadingConfirmationDocument: 'Подтверждение коносамента',
  DataCustomersReleaseNotAllowed: 'В данных есть клиент из черного списка, выпуск документов запрещен!',
  AreToUseAnNumber: 'Подтверждаете использование пустого номера выпуска?',
  Invoice: 'Выставление счета',
  EquivalentToRMB: 'Эквивалент в RMB:',
  ReconciliationFlowNumber: 'Номер операции списания',
  CounterpartyUnit: 'Контрагент',
  OurBank: 'Наш банк',
  PaymentNoticeNumber: 'Номер платежного уведомления',
  VoucherNumber: 'Номер документа',
  BankSlipNumber: 'Номер банковской выписки',
  ReconciliationPerson: 'Исполнитель списания',
  ReconciliationDate: 'Дата списания',
  ReceiptpaymentDate: 'Дата поступления/платежа',
  VoucherDate: 'Дата документа',
  SlipStatus: 'Статус выписки',
  ReceiptpaymentMethod: 'Способ оплаты/поступления',
  WhetherPrepaid: 'Предоплата',
  Amount: 'Сумма',
  AmountReconciled: 'Списано',
  Balance: 'Остаток',
  ActualAmountReceived: 'Фактически получено',
  ActualPaymentAmount: 'Фактически оплачено',
  FinancialExpense: 'Финансовые расходы',
  ExchangeGainloss: 'Курсовые разницы',
  SmallHead: 'Недостача/излишки',
  OriginalCurrencyDifference: 'Курсовая разница в исходной валюте',
  Review: 'Проверка',
  ReviewDate: 'Дата проверки',
  Void: 'Аннулировать',
  InvoiceInformation: 'Реквизиты счета',
  AccountPerioddays: 'Срок оплаты (дни)',
  CounterpartyVoucherNumber: 'Номер документа контрагента',
  VoucherDate2: 'Дата документа 2',
  FailedToModifyReconciliation: 'Не удалось изменить списание',
  OffsetSearchAndSelectThe: 'Взаимозачет: выберите все позиции для зачета',
  Fees: 'Расходы',
  Invoices: 'Счет',
  Statements: 'Счет-фактура',
  AccountStatements: 'Выписка',
  PaymentApplications: 'Заявка на оплату',
  PlatformCustomerService: 'Служба поддержки платформы',
  FailedToRevokeReconciliation: 'Не удалось отменить списание',
  Equivalent: 'Эквивалент',
  PaymentAmount: 'Сумма платежа',
  PaymentMethod: 'Способ оплаты',
  NotUsed: 'Не использовано',
  PendingSlip: 'Водяной знак',
  ReceivedReceipt: 'Получить квитанцию',
  Reconciliation: 'Списание',
  Company1: 'Компания 1',
  CloseAndCopyFlowNumber: 'Закрыть и скопировать номер транзакции',
  Close: 'Закрыть',
  CopySuccessful: 'Копирование успешно',
  IfLoadingSpeedAreAgo: 'Если выбранный диапазон дат превышает 2 года, это повлияет на скорость загрузки данных. Вы уверены, что хотите запросить данные за пределами двух лет?',
  FinancialComprehensiveQuery: 'Комплексный финансовый запрос',
  ExportEstimationForm: 'Экспорт оценочной таблицы',
  ExportingMailboxLaterPleaseMailbox: 'Идет экспорт, файл будет отправлен на почту пользователя. Пожалуйста, проверьте почту.',
  ChineseName: 'Китайское название',
  ClosingRecords: 'Запись закрытия счета',
  ClosingReview: 'Проверка закрытия счета',
  PleaseCheckARecord: 'Пожалуйста, отметьте одну запись.',
  PleaseAReconciliationRuleName: 'Введите название правила сверки',
  PleaseSelectABranch: 'Выберите филиал',
  DeleteSuccessful: 'Удаление успешно',
  PleaseReconciliationRuleToEdit: 'Выберите правило сверки для редактирования',
  PleaseTheMatchingFieldOrder: 'Введите порядок сопоставления полей',
  PleaseTheMatchingFieldName: 'Выберите название сопоставляемого поля',
  PleaseTheContrastFieldOrder: 'Введите порядок сравнения полей',
  PleaseTheContrastFieldName: 'Выберите название сравниваемого поля',
  PleaseTheContrastFieldOperation: 'Выберите операцию сравнения полей',
  EnterReconciliationAmount: 'Введите [сумму сверки] во внутренней таблице, убедитесь, что итоговые суммы сверки слева и справа совпадают, затем выполните ручную сверку.',
  XNotAllowViewOrDownload: 'Файл {0} не разрешен для просмотра или скачивания.',
  NoPermissionView: 'У вас нет прав для просмотра или скачивания файла {0}.',
  SelectedNotAllowedToCheck: 'В выбранных данных есть операции не в состоянии {0}, проверка невозможна. Пожалуйста, проверьте!',
  N0isBeVoidedPleaseNote: '【{0}】 - это электронный счет, его нельзя аннулировать, выполните сторнирование.',
  N0isCannotBeVoidedNote: '【{0}】 - это счет за пределами месяца, его нельзя аннулировать, выполните сторнирование.',
  N0VoidedAndCannotCredited: '{0} уже аннулирован, сторнирование невозможно!',
  N0hasOffAndCannotCredited: '{0} уже погашен, сторнирование невозможно!',
  N0ItemsDownloadable: 'шт., доступно для скачивания',
  N0ItemsConfirmDownload: 'шт., подтвердить скачивание?',
  TelexContact0ToApplication: 'Заявка на электронный выпуск уже подана, свяжитесь с {0} для отмены.',
  DocumentaryStatus: 'Статус документа',
  GotIt: 'Понятно',
  CurrencyConversionColumnSet: 'Настройка отображения конвертированной валюты',
  CurrencyConversionSet: 'Настройка конвертированной валюты',
  ShowColumns: 'Отображаемые столбцы',
  CurrencyConversionColumnSetNote: 'Примечание: после выбора валюты система автоматически создаст столбцы для отображения суммы в исходной валюте или суммы расходов, конвертированной в выбранную валюту.',
  CheckAtLeastOneDisplayColumn: 'Пожалуйста, выберите хотя бы один отображаемый столбец.',
  InvoiceWrittenOffWantDeleteIt: 'Счет уже погашен, вы уверены, что хотите удалить?',
  InvoiceWrittenOffWantRevokedIt: 'Счет уже погашен, вы уверены, что хотите аннулировать?',
  InvoiceWrittenOffWantRedPunchIt: 'Счет уже погашен, вы уверены, что хотите выполнить сторнирование?',
  RedPunchInvoice: 'Сторнированный счет',
  BatchCheckRedFlushInvoiceMessageOne: '1. Если выбрана ошибка в выставлении счета, система автоматически создаст новые расходы для выставления счета на основе исходных.',
  BatchCheckRedFlushInvoiceMessageTwo: '2. При выборе прекращения услуги, скидки на продажу или возврата товара, обратите внимание на ручной ввод правильных расходов',
  BatchCheckRedFlushInvoiceMessageThree: '2. При выборе прекращения услуги или скидки на продажу, обратите внимание на ручной ввод правильных расходов',
  IncorrectInvoiceInformation: 'Ошибка в информации о счете-фактуре',
  IncorrectChargeInformation: 'Ошибка в информации о расходах',
  BatchCheckRedPunchInvoiceMessageOne: '1. При выборе "Ошибка в информации о счете-фактуре" система автоматически создаст новые расходы для выставления счета на основе исходных данных',
  BatchCheckRedPunchInvoiceMessageTwo: '2. При выборе "Ошибка в информации о расходах" обратите внимание на ручной ввод правильных расходов',
  ContinueRedPunchAtVoucher: 'Счет-фактура содержит уже созданные проводки. Подтвердите сторнирование?',
  WhtDeduction: 'Вычет WHT',
  WhtDeductionAmount: 'Сумма вычета WHT',
  ReceivableWHTTaxAmount: 'Дебиторская задолженность за вычетом налога WHT',
  PayableWHTTaxAmount: 'Кредиторская задолженность за вычетом налога WHT',
  TotalExcludingTax: 'Итого (без налога)',
  TotalIncludingTax: 'Итого (с налогом)',
  NewGeneration: 'Статус отправки в новое поколение',
  PushState: 'Режим нажатия',
  PushFailReason: 'Причины неудачи',
  ManualMatching: 'Ручное сопоставление',
  SelectBusinessNumber: 'Выберите соответствующий номер операции',
  ManualMatchByBoxNo: 'Ручное сопоставление по номеру контейнера',
  ManualMatchByWarehouseNo: 'Ручное сопоставление по номеру поступления на склад',
  FreeMatch: 'Свободное сопоставление',
  SelectSameSupplierNumberMatch: 'Выберите одинаковые номера поставщиков для ручного сопоставления.',
  BusinessNoMblSoNoNotEmpty: 'Номер операции, основной номер и SO NO не могут быть пустыми одновременно',
  SelectCorrespondeBusiness: 'Выберите соответствующую операцию',
  CostSyncColudStatus: 'Статус синхронизации расходов с облачной платформой',
  SyncCloudExceptionReason: 'Причина ошибки синхронизации с облачной платформой',
  ManualSynchronization: 'Ручная синхронизация',
  SelectNotSyncManualPush: 'Отметьте данные с статусом "Не синхронизировано" для ручной отправки',
  SyncChargeNotSplit: 'Синхронизированные расходы нельзя разделять',
  SyncCloudPlatformStatus: 'Статус синхронизации с облачной платформой',
  InvoiceNoEmptyNotPush: 'Номер счета-фактуры пуст, отправка невозможна',
  InvoicePushNotAgain: 'Не отправляйте уже отправленные счета-фактуры повторно',
  SentYongYouRedFlush: 'Данные уже отправлены в Yonyou, выполните сторнирование',
  InvoiceTitleNotSync: 'Реквизиты счета-фактуры "{0}" не синхронизированы с Yonyou. Сначала выполните синхронизацию.',
  OnlySupportInternal: 'Интерфейс не поддерживает зарубежные расходы. Выберите внутренний счет-фактуру.',
  NotSupportMultiCurrency: 'Обнаружены счета-фактуры в разных валютах. Невозможно отправить в Yonyou. Откорректируйте данные.',
  OnlySupportRmb: 'Валюта счета-фактуры не RMB. Невозможно отправить в Yonyou.',
  PayableInvoiceActualReceiptDateEmpty: 'Дата фактического получения счета-фактуры к оплате не может быть пустой. Заполните поле.',
  PushYongYouInvoiceNeedRMB: 'Для отправки счета-фактуры в Yonyou валюта должна быть RMB',
  OffsetRedPunchTipU8C: 'Согласно требованиям группы, сторнированные счета-фактуры нельзя отправлять. Обработайте вручную.',
  AccountsReceivable: 'Дебиторская задолженность:',
  PayableColon: 'Кредиторская задолженность:',
  PrintByAccountNumber: 'Печать по номеру счета',
  PrintAccordingAccountNumber: 'Печать по номеру выписки',
  PrintByPaymentRequestNumber: 'Печать по номеру заявки на оплату',
  PushUFIDANeedReceiptDate: 'Для отправки в систему проводок Yonyou необходимо указать дату фактического получения счета-фактуры к оплате',
  WhenShareFinanceCost: '(При распределении финансовых расходов)',
  ReceivablesVerificationStatus: 'Статус проверки дебиторской задолженности',
  UnlockLedgerBatchNo: 'Номер партии',
  UnlockLedgerApplyUser: 'Заявитель',
  UnlockLedgerStatus: 'Статус',
  UnlockLedgerOrderCount: 'Кол-во заказов',
  UnlockLedgerDeclaredImpact: 'Заявл. влияние на маржу',
  UnlockLedgerBeforeProfit: 'Маржа до разблокировки',
  UnlockLedgerAfterProfit: 'Маржа после разблокировки',
  UnlockLedgerActualImpact: 'Факт. влияние на маржу',
  UnlockLedgerRelockTime: 'Время автозаблокировки',
  UnlockLedgerApplyTime: 'Время подачи',
  UnlockLedgerStatus0: 'На рассмотрении',
  UnlockLedgerStatus1: 'Разблокировка',
  UnlockLedgerStatus2: 'Заблокировано',
  UnlockLedgerStatus3: 'Отклонено',
  UnlockLedgerManualRemarks: 'Примечания к ручной блокировке',
  UnlockLedgerStatus9: 'Ошибка',
  UnlockLedgerDetailTitle: 'Детали заявки на разблокировку',
  UnlockLedgerApplyInfo: 'Информация о заявке',
  UnlockLedgerSpNo: 'Номер согласования WeCom',
  UnlockLedgerUnlockTime: 'Время разблокировки',
  UnlockLedgerPlanRelockTime: 'Плановое время блокировки',
  UnlockLedgerActualRelockTime: 'Факт. время блокировки',
  UnlockLedgerFailReason: 'Причина ошибки',
  UnlockLedgerJobs: 'Снимки заказов',
  UnlockLedgerJobNo: 'Номер заказа',
  UnlockLedgerCustomerName: 'Клиент',
  UnlockLedgerBeforeReceivable: 'Дебиторка до разблокировки',
  UnlockLedgerBeforePayable: 'Кредиторка до разблокировки',
  UnlockLedgerAfterReceivable: 'Дебиторка после блокировки',
  UnlockLedgerAfterPayable: 'Кредиторка после блокировки',
  UnlockLedgerDiffTab: 'Детали изменений расходов',
  UnlockLedgerJobFilter: 'Фильтр по заказу',
  UnlockLedgerChargeName: 'Наименование расхода',
  UnlockLedgerChangeType: 'Тип изменения',
  UnlockLedgerChangeType0: 'Добавление',
  UnlockLedgerChangeType1: 'Изменение',
  UnlockLedgerChangeType2: 'Удаление',
  UnlockLedgerFieldChanges: 'Изменённые поля',
  UnlockLedgerModifyUser: 'Изменил',
  UnlockLedgerModifyTime: 'Время изменения',
  UnlockLedgerDiffEmptyTip: 'Нет изменений (изменения расходов формируются при блокировке)',
  UnlockLedgerTip: 'Изменение расходов заблокированных заказов требует разблокировки через согласование WeCom; после одобрения разблокировка выполняется автоматически, повторная блокировка — автоматически в 01:00 через 3 дня; все изменения фиксируются'
}
